import {Helpers} from '../helpers/helpers';
import UrlService from '../services/UrlService';
import {PaginationResponse} from "../types";
import StringHelper from "../helpers/StringHelper";
import TriggeredEvent = JQuery.TriggeredEvent;

export default class ArticlesPage {
    private ARTICLES_URL = '/api/articles/paginated';

    private readonly $holder: JQuery;
    private readonly $articlesListCountResultContainer: JQuery;
    private readonly $articlesListCountResult: JQuery;
    private readonly $articlesListCountResultAdditionText: JQuery;
    private readonly $articlesListEmptyListResult: JQuery;
    private readonly $articlesListWrapper: JQuery;
    private readonly $tagsList: JQuery;
    private readonly $paginationWrapper: JQuery;

    private $filtersForm: JQuery;
    private $search: JQuery;
    private $articlesMagnifier: JQuery;

    private readonly HAS_VALUE_CLASS = 'has-value';

    private readonly selectors = {
        articlesListWrapper: '.js-articles-page-list',
        paginationWrapper: '.js-articles-page-pagination-wrapper',
        filtersForm: '.js-articles-page-filters-form',
        resetAllFilters: '.js-articles-page-filters-reset-button',
        articlesListCountResultContainer: '.js-articles-page-filters-counter-container',
        articlesListCountResult: '.js-list-count-result',
        articlesListCountResultAdditionText: '.js-list-count-result-addition-text',
        articlesListEmptyListResult: '.js-articles-page-empty-list-result',
        tagsList: '.js-articles-page-tags-list',
        typeRadioLabel: '.js-articles-type-radio-label',
        filterItemTypes: '.js-articles-page-filters-item-types',
        filterItem: '.js-articles-page-filters-item',
        search: '.js-articles-search',
        clearSearchInput: '.js-articles-clear-result-search',
        articlesMagnifier: '.js-articles-magnifier',
    };

    private currentPagePagination = 1;

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$articlesListWrapper = this.$holder.find(this.selectors.articlesListWrapper);
        this.$articlesListEmptyListResult = this.$holder.find(this.selectors.articlesListEmptyListResult);
        this.$articlesListCountResultContainer = this.$holder.find(this.selectors.articlesListCountResultContainer);
        this.$articlesListCountResult = this.$holder.find(this.selectors.articlesListCountResult);
        this.$articlesListCountResultAdditionText = this.$holder.find(this.selectors.articlesListCountResultAdditionText);
        this.$tagsList = this.$holder.find(this.selectors.tagsList);
        this.$paginationWrapper = this.$holder.find(this.selectors.paginationWrapper);
        this.$filtersForm = this.$holder.find(this.selectors.filtersForm);
        this.$search = this.$holder.find(this.selectors.search);
        this.$articlesMagnifier = this.$holder.find(this.selectors.articlesMagnifier);

        this.clearCountResult = this.clearCountResult.bind(this);
        this.changeInputValue = this.changeInputValue.bind(this);
        this.changeActiveInputClass = this.changeActiveInputClass.bind(this);
        this.clearSearchInput = this.clearSearchInput.bind(this);
        this.clickPaginationHandler = this.clickPaginationHandler.bind(this);

        void this.init();
    }

    private async init() {
        this.initEvents();
        // нужна для того что бы при возврате на страницу с фильтрами, они были применены
        this.changeFiltersHandler(true);
    }

    // TODO: поле для ввода запроса
    private initEvents(): void {
        const searchValue = this.$search.find('input[name="search"]').val();
        this.changeActiveInputClass(searchValue);

        this.$search.on('input', this.changeInputValue);

        this.$paginationWrapper.on('click', 'a', this.clickPaginationHandler);

        const $labels = this.$holder.find(this.selectors.typeRadioLabel);

        $labels.on('mousedown', (evt) => {
            const $input = $(evt.currentTarget).find('input');
            const isChecked = $input.prop('checked');

            if (isChecked) {
                // если  выбран тэк "все", то при откликивании тэга "все" ничего не делаем
                if ($input.val() === '0') {
                    return;
                }
                $(evt.currentTarget).on('mouseup', this.typeRadioMouseUpHandler);
                return;
            }
        });

        this.$filtersForm.on('change', this.selectors.filterItem, (event) => {
            UrlService.setOrReplaceParam('tag', event.target.value);
            this.changeFiltersHandler(true);
        });

        this.$holder.on('click', this.selectors.resetAllFilters, () => {
            this.resetAllFilters();
        });

        // Обработчик очистки поля поиска
        this.$filtersForm.find(this.selectors.clearSearchInput).on('click', () => {
            this.changeActiveInputClass('');
            this.clearSearchInput();
            this.changeFiltersHandler(true);
        });

        // Обработчик клика на лупу
        this.$articlesMagnifier.on('click', () => {
            const searchValue = this.$search.find('input[name="search"]').val();
            this.changeActiveInputClass(searchValue);

            if (searchValue) {
                UrlService.setOrReplaceParam('search', searchValue as string);
            } else {
                UrlService.deleteUrlParam('search');
            }

            this.changeFiltersHandler(true);
        });
    }

    private clearCountResult(): void {
        this.$articlesListCountResultContainer.hide();
        this.$articlesListCountResult.html('');
        this.$articlesListCountResultAdditionText.html('').hide();
    }

    private changeInputValue(event: TriggeredEvent<HTMLElement, undefined, HTMLElement, HTMLElement>): void {
        const $inputValue = $(event.target).val();

        this.changeActiveInputClass($inputValue);
    }

    private changeActiveInputClass(value: string | number | string[]) {
        value
            ? this.$search.addClass(this.HAS_VALUE_CLASS)
            : this.$search.removeClass(this.HAS_VALUE_CLASS);
    }

    private clearSearchInput(): void {
        this.clearCountResult();

        this.$search.find('input[name="search"]').val('');

        UrlService.deleteUrlParam('search');
    }

    private typeRadioMouseUpHandler(evt: JQuery.MouseUpEvent): void {
        evt.preventDefault();

        const $input = $(evt.currentTarget).find('input');

        setTimeout(() => {
            $input.prop('checked', false);

            $input.trigger('change');
        }, 5);

        $(evt.currentTarget).off('mouseup', this.typeRadioMouseUpHandler);
    }

    private resetAllFilters(): void {
        this.$filtersForm
            .find(this.selectors.filterItemTypes)
            .each((_, input) => {
                $(input).prop('checked', false);
            });

        this.$filtersForm
            .find(this.selectors.filterItemTypes)
            .filter('[value="0"]')
            .prop('checked', true);

        this.clearSearchInput();

        // обнуляем query без обновы страницы
        UrlService.clearUrlParams();

        // Скрываем counter и делаем пустым его html
        this.$articlesListCountResultContainer.hide();
        this.$articlesListCountResult.html('')

        this.changeFiltersHandler(true);
    }

    private clickPaginationHandler(evt: JQuery.ClickEvent): void {
        evt.preventDefault();

        const $currentTarget = $(evt.currentTarget);
        const href = $currentTarget.attr('href');

        if (!href) {
            return;
        }

        const page = UrlService.getParamValueByName('page', href);

        if (!page) {
            return;
        }

        this.currentPagePagination = Number(page);
        this.changeFiltersHandler(false);
    }

    private getFilterParams(): Array<JQuery.NameValuePair> {
        let result: Array<JQuery.NameValuePair> = [];

        result.push({
            name: 'page',
            value: this.currentPagePagination.toString(),
        })

        return [...result, ...this.$filtersForm.serializeArray()];
    }

    private changeFilterTimeoutId: NodeJS.Timeout | null = null;

    private changeFiltersHandler(isResetPagination = true): void {
        if (isResetPagination) {
            this.currentPagePagination = 1;
        }

        if (this.changeFilterTimeoutId) {
            clearTimeout(this.changeFilterTimeoutId);
        }

        this.changeFilterTimeoutId = setTimeout(() => {
            this.fetchArticles();
        }, 300);
    }

    private isLoading = false;

    private fetchArticles(): void {
        this.isLoading = true;

        const params = this.getFilterParams();
        const hasFilters = Helpers.hasFiltersValue(params.filter((param) => param.name !== 'page'));

        if (hasFilters) {
            this.$holder.addClass('has-filters')
        } else {
            this.$holder.removeClass('has-filters')
        }

        this.isLoading = true;
        this.$holder.addClass('is-loading');
        void $.ajax({
            url: this.ARTICLES_URL,
            type: 'GET',
            dataType: 'json',
            data: params,
        }).done((data: PaginationResponse) => {
            this.prepareArticlesResponse(data);
            this.isLoading = false;

            if (!Helpers.isTopInViewPort(this.$holder)) {
                Helpers.scrollTo(this.$holder.get(0) as HTMLElement);
            }

            this.$holder.removeClass('is-loading');
        });
    }

    private prepareArticlesResponse(data: PaginationResponse): void {
        const totalCount = data.response.total;

        const countText = StringHelper.plural(['результат', 'результата', 'результатов'], totalCount);

        const searchValue = this.$search.find('input[name="search"]').val();

        const foundAdditionText = StringHelper.plural(['найден', 'найдено', 'найдено'], totalCount);
        const countAdditionText = `${foundAdditionText} по запросу «${searchValue}»`;

        this.$articlesListCountResult.html(`${totalCount.toString()} ${countText}`);

        if (searchValue) {
            this.$articlesListCountResultAdditionText.show().html(countAdditionText);
            this.$articlesListCountResultContainer.show();
        }

        if (!totalCount) {
            this.$articlesListEmptyListResult.show();
            this.$articlesListWrapper.hide();
            this.$tagsList.hide();
            this.$paginationWrapper.hide();
            return;
        }

        this.$articlesListEmptyListResult.hide();

        this.$tagsList.show();
        this.$articlesListWrapper.show().html(data.response.html.items);
        this.$paginationWrapper.show().html(data.response.html.pagination);
    }
}
